import { DataFrame } from '../DataFrame';
import { DataSeries } from '../DataSeries';
import { DataPoint } from '../DataPoint';
import { IDimension } from '../Dimensions';

// eslint-disable-next-line consistent-return
export const fromDataPrimitive = (dp: IDimension): DataFrame => {
    if (DataFrame.isDataFrame(dp)) {
        return dp;
    }
    if (DataSeries.isDataSeries(dp)) {
        return new DataFrame([dp]);
    }
    if (DataPoint.isDataPoint(dp)) {
        return new DataFrame([new DataSeries([dp])]);
    }
};
